import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { TimeRangeInput } from 'dashboards/types/time';
import { FilterInput } from 'dashboards/types/filter';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

type UseCounterParams = {
  metricName: string;
  timeRange: TimeRangeInput;
  timeZone: string;
  filters: Array<FilterInput>;
};

type UseCounterOptions = UseQueryOptions<{ value: string }, APIError> & {
  params: UseCounterParams;
};

export function useCounter({
  queryKey = ['counter'],
  params,
  ...options
}: UseCounterOptions) {
  const { applicationID, client } = useAPI();

  return useAuthenticatedQuery(
    [...queryKey, params],
    async () => {
      const { data } = await client.post(
        `/apps/${applicationID}/user_metrics/counter`,
        params
      );

      return data;
    },
    { ...options }
  );
}
